module.exports = __webpack_public_path__ + "static/media/top-celeste.49fe3327.jpg";